import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import CustomStore from 'devextreme/data/custom_store';
import { LoadOptions } from '../../../../shared/models/shared.model';
import { CompanyDataService } from '../../../../api/company-data.service';
import { UserApi } from '../../../../api';
import { FilterBuilderService } from '../../../../service/filter-builder.service';
import { LoaderService } from '../../../../core/loader/loader.service';
import { Subject } from 'rxjs';
import {GridSetting, GridSettings, GridState, User} from '../../../../shared';
import { BarcodeDataService } from '../../../../api/barcode-data.service';
import {
  BarcodeGlobalCompanyPrefixMappingOption
} from '../../../../shared/models/barcode-mapping.model';
import { MappingAction, MappingMode } from '../../../../shared/enum/mapping-mode.enum';
import {take, takeUntil} from 'rxjs/operators';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {
  BarcodeGlobalCompanyPrefixEditComponent
} from './global-company-prefix-edit/barcode-global-company-prefix-edit.component';

@Component({
  selector: 'app-barcode-global-company-prefix',
  templateUrl: 'global-company-prefix.component.html'
})

export class BarcodeGlobalCompanyPrefixComponent implements OnInit, OnDestroy {
  @ViewChild('barcodeGlobalCompanyPrefixMappingDataGrid') barcodeGlobalCompanyPrefixMappingDataGrid: DxDataGridComponent;
  @ViewChild('companyMasterDataGrid') companyMasterDataGrid: DxDataGridComponent;

  barcodeGlobalCompanyPrefixMappingDataSource = {};
  barcodeGlobalCompanyPrefixMappingSelectedRowMap: any;
  dataProviderCodeHeaderDataSource: any;
  mappingModeHeaderDataSource: any;
  createdByHeaderDataSource: any;
  createdOnHeaderDataSource: any;
  modifiedByHeaderDataSource: any;
  modifiedOnHeaderDataSource: any;
  reviewedByHeaderDataSource: any;
  productBrandingLevelIdHeaderDataSource: any;
  productBrandingLevelNameHeaderDataSource: any;
  productMasterEntityIdNameHeaderDataSource: any;
  companyNameHeaderDataSource: any;
  masterBrandNameHeaderDataSource: any;
  brandNameHeaderDataSource: any;
  businessEntityNameHeaderDataSource: any;
  websiteHeaderDataSource: any;
  commentHeaderDataSource: any;
  mappingModeNameHeaderDataSource: any;

  subBrandNameHeaderDataSource: any;
  reviewedOnHeaderDataSource: any;
  companyMasterDataSource = {};
  companyMasterSelectedRowMap = [];
  brandingLevelHeaderDataSource: any;
  sourceCompanyHeaderDataSource: any;
  masterTableBrandNameHeaderDataSource: any;
  masterTableMasterBrandNameHeaderDataSource: any;
  masterTableSubBrandNameHeaderDataSource: any;
  currentUser: User;

  private isCompanyMasterDataLoading = true;
  private isGlobalCompanyPrefixMappingDataLoading = true;
  private _destroyed$ = new Subject();
  private barcodeGlobalCompanyPrefixMappingMappingSelectedRowIndex: number;

  public isLoadBarcodeGlobalCompanyMappingGridDataSource: boolean;
  public isLoadBarcodeGlobalCompanyMasterGridDataSource: boolean;
  private readonly mappingGridName: string = 'barcodeGlobalCompanyMappingDataGrid';
  private readonly masterGridName: string = 'barcodeGlobalCompanyMasterDataGrid';
  private readonly pageName: string = 'barcodeGlobalCompanyMapping';
  private currentBarcodeGlobalCompanyMappingDataGridState: GridState;
  private currentBarcodeGlobalCompanyMasterDataGridState: GridState;
  private barcodeGlobalCompanyMappingDataGridSettings: GridSettings;
  private barcodeGlobalCompanyMasterDataGridSettings: GridSettings;
  private isBarcodeGlobalCompanyMappingDataGridSettingLoading = true;
  private isBarcodeGlobalCompanyMasterDataGridSettingLoading = true;
  private barcodeGlobalCompanyMappingDataGridSetting: GridSetting = new GridSetting();
  private barcodeGlobalCompanyMasterDataGridSetting: GridSetting = new GridSetting();

  constructor(
	private companyDataService: CompanyDataService,
	private userService: UserApi,
	private filterBuilder: FilterBuilderService,
	private loaderService: LoaderService,
	private barcodeDataService: BarcodeDataService,
	private modalService: NgbModal,
  ) {
  }

  ngOnInit() {
	this.loaderService.show();
	this.currentUser = this.userService.logonUser;
	if (!this.currentUser) {
		return;
	}
	this.barcodeGlobalCompanyMappingDataGridSettings = {
		PageName: this.pageName,
		GridName: this.mappingGridName,
		OwnedByUserId: this.currentUser.UserId
	};
	this.userService.getGridSettings(this.barcodeGlobalCompanyMappingDataGridSettings)
		.pipe(take(1))
		.subscribe((settings) => {
		if (settings && settings.Settings) {
			if (typeof settings.Settings === 'string') {
			this.barcodeGlobalCompanyMappingDataGridSetting = JSON.parse(settings.Settings);
			} else {
			this.barcodeGlobalCompanyMappingDataGridSetting = settings.Settings;
			}
		} else {
			this.barcodeGlobalCompanyMappingDataGridSettings.Settings = JSON.stringify({autosave: true});
			this.updateGridSettings(this.barcodeGlobalCompanyMappingDataGridSettings);
		}
		this.loadBarcodeGlobalCompanyMappingDataGridState();
		});

	this.barcodeGlobalCompanyMasterDataGridSettings = {
		PageName: this.pageName,
		GridName: this.masterGridName,
		OwnedByUserId: this.currentUser.UserId
	};

	this.userService.getGridSettings(this.barcodeGlobalCompanyMasterDataGridSettings)
		.pipe(take(1))
		.subscribe((settings) => {
		if (settings && settings.Settings) {
			if (typeof settings.Settings === 'string') {
			this.barcodeGlobalCompanyMasterDataGridSetting = JSON.parse(settings.Settings);
			} else {
			this.barcodeGlobalCompanyMasterDataGridSetting = settings.Settings;
			}
		} else {
			this.barcodeGlobalCompanyMasterDataGridSettings.Settings = JSON.stringify({autosave: true});
			this.updateGridSettings(this.barcodeGlobalCompanyMasterDataGridSettings);
		}
		this.loadBarcodeGlobalCompanyMasterDataGridState();
		});

	this.loadGlobalCompanyMasterHeaderFilters();
	this.loadCompanyMasterHeaderFilters();
  }

  private loadBarcodeGlobalCompanyMappingDataSource() {
	this.isBarcodeGlobalCompanyMappingDataGridSettingLoading = false;
	this.barcodeGlobalCompanyPrefixMappingDataSource = new CustomStore({
		key: 'BarcodeGlobalCompanyPrefixMappingId',
		load: (loadOptions: any) => {
		this.isGlobalCompanyPrefixMappingDataLoading = true;
		this.loaderService.show();
		const filter = this.formatFilterOperators(loadOptions.filter);
		const finalOptions: LoadOptions = loadOptions;
		finalOptions.filter = filter;

		return this.barcodeDataService.getGlobalCompanyPrefixMappingGrid(finalOptions)
			.toPromise()
			.then((data: any) => {
			this.isGlobalCompanyPrefixMappingDataLoading = false;
			this.loaderHandler();
			return {
				data: data.data,
				totalCount: data.totalCount,
				summary: data.summary,
				groupCount: data.groupCount
			};
			})
			.catch(error => {
			this.isGlobalCompanyPrefixMappingDataLoading = false;
			this.loaderHandler();
			throw new Error('Data Loading Error');
			});
		}
	});
	this.isLoadBarcodeGlobalCompanyMappingGridDataSource = true;
  }

  private loadBarcodeGlobalCompanyMappingDataGridState() {
	const barcodeGlobalCompanyMappingDataGridState: GridState = {
		PageName: this.pageName,
		GridName: this.mappingGridName,
		OwnedByUserId: this.currentUser.UserId
	};
	this.userService.getGridState(barcodeGlobalCompanyMappingDataGridState)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((state) => {
		if (state) {
			this.currentBarcodeGlobalCompanyMappingDataGridState = state;
		} else {
			this.currentBarcodeGlobalCompanyMappingDataGridState = {
			PageName: this.pageName,
			GridName: this.mappingGridName,
			OwnedByUserId: this.currentUser.UserId,
			State: null
			};
		}
		this.loadBarcodeGlobalCompanyMappingDataSource();
		});
  }

  public loadMappingState = () => {
	return this.currentBarcodeGlobalCompanyMappingDataGridState.State ? JSON.parse(this.currentBarcodeGlobalCompanyMappingDataGridState.State) : null;
  }

  public saveMappingState = (state) => {
	if (this.barcodeGlobalCompanyMappingDataGridSetting) {
		let gridSetting: GridSetting;
		if (typeof this.barcodeGlobalCompanyMappingDataGridSetting === 'string') {
		gridSetting = JSON.parse(this.barcodeGlobalCompanyMappingDataGridSetting);
		} else {
		gridSetting = this.barcodeGlobalCompanyMappingDataGridSetting;
		}
		if (gridSetting.autosave) {
		this.currentBarcodeGlobalCompanyMappingDataGridState.State = JSON.stringify(state);
		this.updateGridState(this.currentBarcodeGlobalCompanyMappingDataGridState);
		}
	}
  }

  private loadBarcodeGlobalCompanyMasterDataSource() {
	this.isBarcodeGlobalCompanyMasterDataGridSettingLoading = false;
	this.companyMasterDataSource = new CustomStore({
		key: 'RowId',
		load: (loadOptions: any) => {
		this.isCompanyMasterDataLoading = true;
		this.loaderService.show();
		const filter = this.formatFilterOperators(loadOptions.filter);
		const finalOptions: LoadOptions = loadOptions;
		finalOptions.filter = filter;

		return this.companyDataService.getBrandingLevelMasterGrid(finalOptions)
			.toPromise()
			.then((data: any) => {
			this.isCompanyMasterDataLoading = false;
			this.loaderHandler();
			return {
				data: data.data,
				totalCount: data.totalCount,
				summary: data.summary,
				groupCount: data.groupCount
			};
			})
			.catch(error => {
			this.isCompanyMasterDataLoading = false;
			this.loaderHandler();
			throw new Error('Data Loading Error');
			});
		}
	});
	this.isLoadBarcodeGlobalCompanyMasterGridDataSource = true;
  }

  private loadBarcodeGlobalCompanyMasterDataGridState() {
	const barcodeGlobalCompanyMasterDataGridState: GridState = {
		PageName: this.pageName,
		GridName: this.masterGridName,
		OwnedByUserId: this.currentUser.UserId
	};
	this.userService.getGridState(barcodeGlobalCompanyMasterDataGridState)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((state) => {
		if (state) {
			this.currentBarcodeGlobalCompanyMasterDataGridState = state;
		} else {
			this.currentBarcodeGlobalCompanyMasterDataGridState = {
			PageName: this.pageName,
			GridName: this.masterGridName,
			OwnedByUserId: this.currentUser.UserId,
			State: null
			};
		}
		this.loadBarcodeGlobalCompanyMasterDataSource();
		});
  }

  public loadMasterState = () => {
	return this.currentBarcodeGlobalCompanyMasterDataGridState.State ? JSON.parse(this.currentBarcodeGlobalCompanyMasterDataGridState.State) : null;
  }

  public saveMasterState = (state) => {
	if (this.barcodeGlobalCompanyMasterDataGridSetting) {
		let gridSetting: GridSetting;
		if (typeof this.barcodeGlobalCompanyMasterDataGridSetting === 'string') {
		gridSetting = JSON.parse(this.barcodeGlobalCompanyMasterDataGridSetting);
		} else {
		gridSetting = this.barcodeGlobalCompanyMasterDataGridSetting;
		}
		if (gridSetting.autosave) {
		this.currentBarcodeGlobalCompanyMasterDataGridState.State = JSON.stringify(state);
		this.updateGridState(this.currentBarcodeGlobalCompanyMasterDataGridState);
		}
	}
  }

  private updateGridSettings(gridSettings: GridSettings) {
	gridSettings.SavedOn = new Date();
	this.userService.setGridSettings(gridSettings).pipe(take(1)).subscribe();
  }

  private updateGridState(gridState: GridState) {
	gridState.SavedOn = new Date();
	this.userService.setGridState(gridState).pipe(take(1)).subscribe();
  }

  selectionMappingDataChangedHandler() {
	if (this.barcodeGlobalCompanyPrefixMappingDataGrid.instance.getSelectedRowsData()[0]) {
		this.barcodeGlobalCompanyPrefixMappingSelectedRowMap =
		this.barcodeGlobalCompanyPrefixMappingDataGrid.instance.getSelectedRowsData()[0];
	}
	this.setBarcodeGlobalCompanyPrefixMappingSelectedRowIndex();
  }

  onReady(e) {
	const grid = e.component;
	const selection = grid.getSelectedRowKeys();
	if (selection.length === 0) {
		grid.selectRowsByIndexes([0]);
	} else {
		if (this.isNextRowAvailable) {
		this.moveToNextRow();
		// this.isMoveToNextRow = false;
		} else {
		this.stayInRow();
		}
	}
  }

  barcodeGlobalCompanyPrefixMappingDataGridContextMenu(e) {
	e.event.stopPropagation();
	if (e.target === 'content') {
		// e.items can be undefined
		if (!e.items) { e.items = []; }

		// Add a custom menu item
		e.items.push(
		{
			text: 'Refresh',
			icon: 'refresh',
			onItemClick: () => {
			this.refreshMappingGrid();
			}
		},
		{
			text: 'Grid Settings',
			items: [
			{
				text: this.barcodeGlobalCompanyMappingDataGridSetting.autosave ? 'Disable autosave' : 'Enable autosave',
				onItemClick: () => {
				this.barcodeGlobalCompanyMappingDataGridSetting.autosave = !this.barcodeGlobalCompanyMappingDataGridSetting.autosave;
				this.barcodeGlobalCompanyMappingDataGridSettings.Settings = JSON.stringify(this.barcodeGlobalCompanyMappingDataGridSetting);
				this.updateGridSettings(this.barcodeGlobalCompanyMappingDataGridSettings);
				}
			}
			]
		}
		);
	}
  }

  refreshMappingGrid() {
	this.barcodeGlobalCompanyPrefixMappingDataGrid.instance.refresh();
  }

  refreshMasterGrid() {
	this.companyMasterDataGrid.instance.refresh();
  }

  selectionMasterDataChangedHandler() {
	if (this.companyMasterDataGrid.instance.getSelectedRowsData()[0]) {
		this.companyMasterSelectedRowMap = this.companyMasterDataGrid.instance.getSelectedRowsData()[0];
	}
  }

  companyMasterDataGridContextMenu(e) {
	if (e.target === 'content') {
		// e.items can be undefined
		if (!e.items) { e.items = []; }

		// Add a custom menu item
		e.items.push(
		{
			text: 'Refresh',
			icon: 'refresh',
			onItemClick: () => {
			this.refreshMasterGrid();
			}
		},
		{
			text: 'Grid Settings',
			items: [
			{
				text: this.barcodeGlobalCompanyMasterDataGridSetting.autosave ? 'Disable autosave' : 'Enable autosave',
				onItemClick: () => {
				this.barcodeGlobalCompanyMasterDataGridSetting.autosave = !this.barcodeGlobalCompanyMasterDataGridSetting.autosave;
				this.barcodeGlobalCompanyMasterDataGridSettings.Settings = JSON.stringify(this.barcodeGlobalCompanyMasterDataGridSetting);
				this.updateGridSettings(this.barcodeGlobalCompanyMasterDataGridSettings);
				}
			}
			]
		}
		);
	}
  }

  createNewGlobalCompanyPrefixData() {
	const modalRef = this.modalService.open(
		BarcodeGlobalCompanyPrefixEditComponent,
		{size: 'lg', backdrop: true}
	);
	modalRef.componentInstance.data = undefined;
	modalRef.componentInstance.currentUser = this.currentUser;
	modalRef.result.then(result => {
		// onclose
		if (result === 'save') {
		this.refreshMappingGrid();
		}
		if (result === 'cancel') {
		this.refreshMappingGrid();
		}
	}, (reason) => {
		// ondismiss
		this.refreshMappingGrid();
	});
  }

  editGlobalCompanyPrefixData(data, isCloning) {
	const modalRef = this.modalService.open(
		BarcodeGlobalCompanyPrefixEditComponent,
		{size: 'lg', backdrop: true}
	);
	modalRef.componentInstance.data = data;
	modalRef.componentInstance.currentUser = this.currentUser;
	modalRef.componentInstance.isCloning = isCloning;
	modalRef.result.then(result => {
		// onclose
		if (result === 'save') {
		this.refreshMappingGrid();
		}
		if (result === 'cancel') {
		this.refreshMappingGrid();
		}
	}, (reason) => {
		// ondismiss
		this.refreshMappingGrid();
	});
  }

  review(barcodeGlobalCompanyPrefixMappingId) {
	const mappingData: BarcodeGlobalCompanyPrefixMappingOption = {};
	mappingData.ModifiedByUserId = this.currentUser.UserId;
	mappingData.BarcodeGlobalCompanyPrefixMappingId = barcodeGlobalCompanyPrefixMappingId;
	mappingData.ActionType = MappingAction.Review;
	this.loaderService.show();
	this.barcodeDataService.mappingGlobalCompanyPrefixAction(mappingData)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res) => {
		this.refreshMappingGrid();
		});
  }

  deactivate(barcodeGlobalCompanyPrefixMappingId: any) {
	const mappingData: BarcodeGlobalCompanyPrefixMappingOption = {};
	mappingData.ModifiedByUserId = this.currentUser.UserId;
	mappingData.BarcodeGlobalCompanyPrefixMappingId = barcodeGlobalCompanyPrefixMappingId;
	mappingData.ActionType = MappingAction.Deactivate;
	this.loaderService.show();
	this.barcodeDataService.mappingGlobalCompanyPrefixAction(mappingData)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res) => {
		this.refreshMappingGrid();
		});
  }

  reactivate(barcodeGlobalCompanyPrefixMappingId: any) {
	const mappingData: BarcodeGlobalCompanyPrefixMappingOption = {};
	mappingData.ModifiedByUserId = this.currentUser.UserId;
	mappingData.BarcodeGlobalCompanyPrefixMappingId = barcodeGlobalCompanyPrefixMappingId;
	mappingData.ActionType = MappingAction.Reactivate;
	this.loaderService.show();
	this.barcodeDataService.mappingGlobalCompanyPrefixAction(mappingData)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res) => {
		this.refreshMappingGrid();
		});
  }

  omit(barcodeGlobalCompanyPrefixMappingId: any) {
	const mappingData: BarcodeGlobalCompanyPrefixMappingOption = {};
	mappingData.MappingModeId = MappingMode.Omitted;
	mappingData.ModifiedByUserId = this.currentUser.UserId;
	mappingData.BarcodeGlobalCompanyPrefixMappingId = barcodeGlobalCompanyPrefixMappingId;
	mappingData.ActionType = MappingAction.Omit;
	this.loaderService.show();
	this.barcodeDataService.mappingGlobalCompanyPrefixAction(mappingData)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res) => {
		this.refreshMappingGrid();
		});
  }

  save(barcodeGlobalCompanyPrefixMappingId: any) {
	const mappingData: BarcodeGlobalCompanyPrefixMappingOption = {};
	mappingData.MappingModeId = MappingMode.Saved;
	mappingData.ModifiedByUserId = this.currentUser.UserId;
	mappingData.BarcodeGlobalCompanyPrefixMappingId = barcodeGlobalCompanyPrefixMappingId;
	mappingData.ActionType = MappingAction.Save;
	this.loaderService.show();
	this.barcodeDataService.mappingGlobalCompanyPrefixAction(mappingData)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res) => {
		this.refreshMappingGrid();
		});
  }

  accept(barcodeGlobalCompanyPrefixMappingId: any) {
	const mappingData: BarcodeGlobalCompanyPrefixMappingOption = {};
	mappingData.ModifiedByUserId = this.currentUser.UserId;
	mappingData.BarcodeGlobalCompanyPrefixMappingId = barcodeGlobalCompanyPrefixMappingId;
	mappingData.ActionType = MappingAction.Accept;
	this.loaderService.show();
	this.barcodeDataService.mappingGlobalCompanyPrefixAction(mappingData)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res) => {
		this.refreshMappingGrid();
		});
  }

  map(companyId: any, productBrandingLevelId: any, productMasterEntityId: any) {
	const mappingData: BarcodeGlobalCompanyPrefixMappingOption = {};
	mappingData.MappingModeId = MappingMode.Mapped;
	mappingData.ModifiedByUserId = this.currentUser.UserId;
	mappingData.ActionType = MappingAction.Map;
	mappingData.CompanyId = companyId;
	mappingData.ProductBrandingLevelId = productBrandingLevelId;
	mappingData.ProductMasterEntityId = productMasterEntityId;
	mappingData.BarcodeGlobalCompanyPrefixMappingId = this.barcodeGlobalCompanyPrefixMappingSelectedRowMap.BarcodeGlobalCompanyPrefixMappingId;
	this.loaderService.show();
	this.barcodeDataService.mappingGlobalCompanyPrefixAction(mappingData)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res) => {
		this.refreshMappingGrid();
		});
  }

  private loadGlobalCompanyMasterHeaderFilters() {
	this.dataProviderCodeHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'GlobalCompanyPrefix';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersGlobalCompanyMapping(loadOptions);
		}
	});

	this.mappingModeNameHeaderDataSource = [
		{
		text: 'New',
		value: 0
		},
		{
		text: 'Map',
		value: 1
		},
		{
		text: 'Save',
		value: 2
		},
		{
		text: 'Omit',
		value: 2
		}
	];

	this.mappingModeHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'MappingModeName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersGlobalCompanyMapping(loadOptions);
		}
	});

	this.createdOnHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CreatedOn';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersGlobalCompanyMapping(loadOptions);
		}
	});

	this.modifiedByHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ModifiedByUserFullNameSortableOrPrincipalName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersGlobalCompanyMapping(loadOptions);
		}
	});

	this.modifiedOnHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ModifiedOn';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersGlobalCompanyMapping(loadOptions);
		}
	});

	this.reviewedByHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ReviewedByUserFullNameSortableOrPrincipalName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersGlobalCompanyMapping(loadOptions);
		}
	});

	this.reviewedOnHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ReviewedOn';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersGlobalCompanyMapping(loadOptions);
		}
	});

	this.productBrandingLevelIdHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ProductBrandingLevelId';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersGlobalCompanyMapping(loadOptions);
		}
	});

	this.productBrandingLevelNameHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ProductBrandingLevelName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersGlobalCompanyMapping(loadOptions);
		}
	});

	this.productMasterEntityIdNameHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ProductMasterEntityId';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersGlobalCompanyMapping(loadOptions);
		}
	});

	this.companyNameHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CompanyName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersGlobalCompanyMapping(loadOptions);
		}
	});

	this.masterBrandNameHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'MasterBrandName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersGlobalCompanyMapping(loadOptions);
		}
	});

	this.brandNameHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'BrandName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersGlobalCompanyMapping(loadOptions);
		}
	});

	this.subBrandNameHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'SubBrandName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersGlobalCompanyMapping(loadOptions);
		}
	});

	this.businessEntityNameHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'BusinessEntityName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersGlobalCompanyMapping(loadOptions);
		}
	});

	this.websiteHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'Website';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersGlobalCompanyMapping(loadOptions);
		}
	});

	this.commentHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'Comment';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersGlobalCompanyMapping(loadOptions);
		}
	});
  }

  private getHeaderFiltersGlobalCompanyMapping(loadingOption) {
	return this.barcodeDataService.getHeaderFiltersGlobalCompanyPrefixMapping(loadingOption)
		.toPromise()
		.catch(error => { throw new Error('Data Loading Error'); });
  }

  private loadCompanyMasterHeaderFilters() {
	this.brandingLevelHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ProductBrandingLevelName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCompanyMaster(loadOptions);
		}
	});

	this.sourceCompanyHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CompanyName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCompanyMaster(loadOptions);
		}
	});

	this.masterTableMasterBrandNameHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'MasterBrandName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCompanyMaster(loadOptions);
		}
	});

	this.masterTableBrandNameHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'BrandName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCompanyMaster(loadOptions);
		}
	});

	this.masterTableSubBrandNameHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'SubBrandName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCompanyMaster(loadOptions);
		}
	});
  }

  private getHeaderFiltersCompanyMaster(loadingOption) {
	return this.companyDataService.getHeaderFiltersCompanyMaster(loadingOption)
		.toPromise()
		.catch(error => { throw new Error('Data Loading Error'); });
  }

  private formatFilterOperators(rawFilter: any[]) {
	if (!rawFilter) {
		return null;
	}
	const filterData = this.filterBuilder.handleNotFilterFormatting(rawFilter);
	return this.filterBuilder.filterFormatting(filterData);
  }

  private loaderHandler() {
	if (
		!this.isGlobalCompanyPrefixMappingDataLoading &&
		!this.isCompanyMasterDataLoading &&
		!this.isBarcodeGlobalCompanyMappingDataGridSettingLoading &&
		!this.isBarcodeGlobalCompanyMasterDataGridSettingLoading) {
		this.loaderService.hide();
	}
  }

  private moveToNextRow() {
	this.setBarcodeGlobalCompanyPrefixMappingSelectedRowIndex();
	this.barcodeGlobalCompanyPrefixMappingDataGrid
		.instance.selectRowsByIndexes([this.barcodeGlobalCompanyPrefixMappingMappingSelectedRowIndex + 1]);
  }

  private stayInRow() {
	this.setBarcodeGlobalCompanyPrefixMappingSelectedRowIndex();
	this.barcodeGlobalCompanyPrefixMappingDataGrid
		.instance.selectRowsByIndexes([this.barcodeGlobalCompanyPrefixMappingMappingSelectedRowIndex]);
  }

  private setBarcodeGlobalCompanyPrefixMappingSelectedRowIndex() {
	const selectedRowKey = this.barcodeGlobalCompanyPrefixMappingSelectedRowMap.BarcodeGlobalCompanyPrefixMappingId;
	const barcodeGlobalCompanyPrefixMappingSelectedRowIndex =
		this.barcodeGlobalCompanyPrefixMappingDataGrid.instance.getRowIndexByKey(selectedRowKey);

	this.barcodeGlobalCompanyPrefixMappingMappingSelectedRowIndex =
		barcodeGlobalCompanyPrefixMappingSelectedRowIndex >= 0 ?
		barcodeGlobalCompanyPrefixMappingSelectedRowIndex :
		this.barcodeGlobalCompanyPrefixMappingMappingSelectedRowIndex;
  }

  private get isNextRowAvailable() {
	const barcodeGlobalCompanyPrefixMappingRowData =
		this.barcodeGlobalCompanyPrefixMappingDataGrid
		.instance
		.getRowElement(this.barcodeGlobalCompanyPrefixMappingMappingSelectedRowIndex + 1);
	if (barcodeGlobalCompanyPrefixMappingRowData) {
		return true;
	}

	return false;
  }

  ngOnDestroy() {
	this.loaderService.hide();
	this._destroyed$.next(null);
	this._destroyed$.complete();
  }
}
